/**
 * @generated SignedSource<<6293a2f60be74ce2d8485856d1fe28b4>>
 * @relayHash 80b12a3b17f379951f67dbc9a9a22f4d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 834d7df01f939ec3a7e68a9b796b5440e7f27239c6064fc3908634ea21eb1f7f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBoardQuery } from './JiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<JiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "834d7df01f939ec3a7e68a9b796b5440e7f27239c6064fc3908634ea21eb1f7f",
    "metadata": {},
    "name": "JiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
